"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useDebounce = require("./useDebounce");
Object.keys(_useDebounce).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useDebounce[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useDebounce[key];
    }
  });
});